import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "DeletedSitePageListViewContainer"
};
const _hoisted_2 = {
  class: "leftCenter"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "colFlex"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "bothCenter colFlex"
};
const _hoisted_7 = {
  key: 1,
  class: "bothCenter colFlex"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "light"
};
const _hoisted_10 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.initQuery ? (_openBlock(), _createBlock(_component_BatterTableDataView, {
    key: 0,
    "table-id": 9,
    "init-query": $data.initQuery,
    ref: "pageList"
  }, {
    title: _withCtx(data => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
      class: "ptr",
      style: {
        "color": "#009FFF"
      },
      onClick: $event => $options.gotoEdit(data.data)
    }, _toDisplayString(data.rowData), 9, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: "https://cdn.waityou.online/2365e64e-2a44-1825-5e8e-bc6f14e27426.svg",
      onClick: $event => $options.previewHtml(data.data),
      class: "ml12 sqr20"
    }, null, 8, _hoisted_5)])])]),
    nav: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data?.data?.nav?.label), 1)]),
    copySize: _withCtx(data => [data.data.copySourceId == null ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(data.rowData), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [_createElementVNode("span", null, "-", -1)])))]),
    subNav: _withCtx(data => [data?.data?.subNav ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(data?.data?.subNav?.label), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_9, "无"))]),
    operate: _withCtx(data => [_createElementVNode("span", {
      style: {
        "color": "red"
      },
      class: "ptr",
      onClick: $event => $options.revertDelete(data.rowId)
    }, "撤销删除", 8, _hoisted_10)]),
    _: 1
  }, 8, ["init-query"])) : _createCommentVNode("", true)]);
}